import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/shared/Heading';
import Divider from 'app/components/bibs/shared/Divider';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from 'app/components/shared/FullScreenOverlay';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import MetadataDisplay from 'app/components/bibs/shared/MetadataDisplay';
import { ChevronLink } from '@bibliocommons/base-links';

import './FullDetails.scss';

export default class FullDetails extends React.PureComponent {
  categoriesInOrder() {
    const { catalogBib } = this.props;
    const fields = catalogBib.get('fields');

    const sortingOrder = [
      'DETAILS',
      'AUDIENCE',
      'SERIES',
      'CONTRIBUTORS',
      'CONTAINS',
      'SUBJECTGENRE',
      'RELATED',
      'NOTES',
      'CALLCLASS',
      'IDENTIFIERS'
    ];

    const sortedFields = fields.sortBy(field => sortingOrder.indexOf(field.get('category')));
    return sortedFields;
  }

  renderContent() {
    const { trackFieldItemClick } = this.props;

    const orderedFields = this.categoriesInOrder();

    return orderedFields.map(field => {
      const fieldCategory = field.get('category');
      const sectionLabelId = `bib_metadata_category_${fieldCategory.toLowerCase()}`;
      if (fieldCategory === 'ABOUT') {
        return null;
      }

      return (
        <div key={fieldCategory}>
          <Divider />
          <div className="field-detail">
            <Heading tagName="h3" size="medium" variant className="field-detail-label">
              <FormattedMessage id={sectionLabelId} />
            </Heading>
            <MetadataDisplay
              fields={field.get('items')}
              handleClick={(fieldItem, fieldValue) => trackFieldItemClick(fieldCategory, fieldItem, fieldValue)}
            />
          </div>
        </div>
      );
    });
  }

  renderLinkToMarcPage() {
    return (
      <ChevronLink
        href={`/v2/record/${this.props.catalogBib.get('metadataId')}/originalrecord`}
        dataKey="original-record-link"
      >
        <FormattedMessage id="original_record" />
      </ChevronLink>
    );
  }

  render() {
    const metadataId = this.props.catalogBib.get('metadataId');

    return (
      <FullScreenOverlayBody className="cp-full-details">
        <FullScreenOverlayHeader title={<FormattedMessage id="full_details" />} />
        <FullScreenOverlayContent size="medium">
          <div className="full-details-brief">
            <BibBriefContainer metadataId={metadataId} />
          </div>
          {this.renderContent()}
          <Divider />
          {this.renderLinkToMarcPage()}
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

FullDetails.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};
